<template>
    <footer class="sticky-footer">
        <div class="container my-auto">
            <div class="copyright text-center my-auto">
                <span>Made with Vue and <span class="text-danger">&hearts;</span> by 24/CO 2022</span>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
    name: 'main-footer'
}
</script>
